/**
 * The URL for the notifications service worker for this repository
 */
export const NOTIFICATIONS_SERVICE_WORKER_URL = '/notifications/service-worker.js';

/**
 * url of the navigation service worker script so we can unregister it in favor of ours
 */
export const LEGACY_NOTIFICATIONS_SERVICE_WORKER_URL = '/unified-nav/notifications-service-worker.js';

/**
 * Identifies the notification action that opens the notification preferences when clicked
 */
export const NOTIFICATION_PREFERENCES_ACTION_ID = 'go-to-preferences';